import Client from '@/services/api/internal/tools/client';
import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';
import BaseAPI from '@/services/api/internal/tools/baseAPI';
import { formatGMTDateToJavascriptDate } from '@/business/utils/dates';

const AlertsAPI = new BaseAPI({
  url: `${process.env.MYPREDITY_BASE_URI}/hypervision_alerts`,
});

export function getSensorsQualityFromList(idList) {
  const url = `${process.env.MYPREDITY_BASE_URI}/properties/sensors_quality`;
  return Client.post(
    url,
    { properties: idList },
    {
      __retry: { nbLeft: 2, timeout: 2000 },
    }
  )
    .then((response) => {
      return response.data.sensors_quality;
    })
    .catch(errorHandler);
}

export function getEnergyCasesFromList(idList) {
  const url = `${process.env.MYPREDITY_BASE_URI}/properties/energy_cases`;
  return Client.post(
    url,
    { properties: idList },
    {
      __retry: { nbLeft: 2, timeout: 2000 },
    }
  )
    .then((response) => {
      return response.data.energy_cases.map((item) => ({
        ...item,
        last_reading_date: formatGMTDateToJavascriptDate(
          item.last_reading_date
        ),
      }));
    })
    .catch(errorHandler);
}

export default AlertsAPI;
